// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"765":"c1f09d4a","787":"3061d5e1"}[chunkId] + ".chunk.js";
};